import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_70: FaireProductEntity = {
  token: "catalog_prod_prod-70",
  type: "product",
  name: "Teak Root Sculpture on Stand - Style 3",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 41.29,
  msrpDollars: 103.23,
  sku: "JA0070",
  caseSize: 1,
  material: "Glass",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 408,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_gift-wrapping"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
